/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ folder: NonNullable<unknown> }} Files_Add_Files_To_FolderInputs */

const en_files_add_files_to_folder = /** @type {(inputs: Files_Add_Files_To_FolderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add files to ${i?.folder}`)
};

const es_files_add_files_to_folder = /** @type {(inputs: Files_Add_Files_To_FolderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agregar archivos a ${i?.folder}`)
};

/**
* | output |
* | --- |
* | "Add files to {folder}" |
*
* @param {Files_Add_Files_To_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_add_files_to_folder = /** @type {((inputs: Files_Add_Files_To_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Add_Files_To_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_add_files_to_folder(inputs)
	return en_files_add_files_to_folder(inputs)
});